import clsx from "clsx";
import { InfoIcon } from "./icons";

export default function Toast({ variant = "neutral", title, message }) {
  return (
    <div className={clsx("toast", `toast--${variant}`)}>
      <span className="toast__badge">
        <InfoIcon className="toast__badge-icon" />
      </span>
      <div className="toast__body">
        {title && <p className="toast__title">{title}</p>}
        {message && <p className="toast__message">{message}</p>}
      </div>
    </div>
  );
}
